/**
 * smoothReload — shows a branded full-screen fade-in overlay with a
 * spinner before calling window.location.reload(). Gives the user
 * clear visual feedback that the UI is refreshing rather than
 * appearing to freeze or flicker.
 *
 * @param {number} [delay=1200]  ms to show the overlay before reload
 * @param {string} [message]     optional status message shown under spinner
 */
export function smoothReload(delay = 1200, message = 'Refreshing workspace…') {
    // Prevent duplicate overlays
    if (document.getElementById('__smooth-reload-overlay__')) return;

    // Enforce light color-scheme on document root to prevent dark-mode unload flash
    document.documentElement.style.setProperty('color-scheme', 'light', 'important');
    document.body.style.setProperty('background-color', '#F7F7F7', 'important');

    const overlay = document.createElement('div');
    overlay.id = '__smooth-reload-overlay__';

    overlay.innerHTML = `
        <style>
            @keyframes __sr-fade-in { from { opacity: 0 } to { opacity: 1 } }
            @keyframes __sr-spin    { to { transform: rotate(360deg) } }
            @keyframes __sr-pulse   { 0%,100% { opacity:1 } 50% { opacity:.4 } }

            #__smooth-reload-overlay__ {
                position: fixed;
                inset: 0;
                z-index: 99999;
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                gap: 20px;
                background: #F7F7F7; /* Solid app main background prevents transparency flashes */
                animation: __sr-fade-in 0.25s ease forwards;
            }

            #__smooth-reload-overlay__ .__sr-ring {
                width: 52px;
                height: 52px;
                border-radius: 50%;
                border: 3.5px solid rgba(240, 74, 35, 0.15);
                border-top-color: #2276E9;
                animation: __sr-spin 0.75s linear infinite;
            }

            #__smooth-reload-overlay__ .__sr-logo {
                font-size: 13px;
                font-weight: 700;
                letter-spacing: 0.04em;
                color: #2276E9;
                animation: __sr-pulse 1.6s ease-in-out infinite;
            }

            #__smooth-reload-overlay__ .__sr-msg {
                font-size: 13px;
                font-weight: 500;
                color: #64748B;
                letter-spacing: 0.01em;
            }
        </style>
        <div class="__sr-ring"></div>
        <span class="__sr-logo">VELOCITY RFP</span>
        <span class="__sr-msg">${message}</span>
    `;

    document.body.appendChild(overlay);

    setTimeout(() => {
        window.location.reload();
    }, delay);
}
